export default {"src":"/_next/static/media/calculator_resource.26b28719.svg","height":490,"width":489,"blurWidth":0,"blurHeight":0};